module.exports = __webpack_public_path__ + "img/TZS09465.e0b4c15a.jpeg";